export default "__VITE_ASSET__6098cbe1__"